export default __webpack_public_path__ + "static/media/2.335109f1.jpg";